export const URL_GET_FORM = 'info/conference-templates';
export const URL_UPLOAD = 'conference/upload-template';
export const URL_DOWNLOAD = 'admin/download/sample-account-file';
export const URL_EXPPORT_ACCOUNT = 'info/admin/export';
export const GET_LIST = 'GET_FORM_LIST_LIST';
export const SET_FILTER = 'SET_FORM_LIST_FILTER';
// export const SET_TOTAL = 'SET_FORM_TOTAL';
export const SET_SENDING = 'SET_SHAREHOLDER_STATUS_SENDING';
